import { Component, OnInit, Input } from '@angular/core';
import { PayService } from '../../invoices/pay.service';
import { PopoverController } from '@ionic/angular';
import { DialogService } from '../../_services';
import { StringConstants } from '../../_constants/stringConstants';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'invoice-bank-selection',
  templateUrl: './invoice-bank-selection.component.html'
})
export class InvoiceBankSelectionComponent implements OnInit {
  // private changePaymentMethod : string = this.translate.instant('CHANGING_PAYMENT_METHOD');
  // private cancel : string = this.translate.instant('LABELS.CANCEL');
  // private ok : string = this.translate.instant('LABELS.OK');
  // private pleaseConfirm = this.translate.instant('PLEASE_CONFIRM');

  @Input() payData: any = {};
  selectedBank;
  payModel;
  constructor(
    private payService: PayService,
    private modal: PopoverController,
    private dialogService: DialogService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.payModel = this.payData.payModel;
    this.selectedBank = this.payModel.bank || [];
  };

  setPaymentMode() {
    const changePayMethod = () => {
      this.payData.clearCreditNotesSelection();
      this.payModel.bank = this.selectedBank;
      this.payData.setPaymentMode();
    }
    if (this.payData.creditNotesSelected) {
      this.dialogService.showConfirmDialog({
        header: this.translate.instant('MESSAGES.CHANGING_PAYMENT_METHOD'),
        message: this.translate.instant('MESSAGES.PLEASE_CONFIRM'),
        ok: this.translate.instant('LABELS.OK'),
        cancel: this.translate.instant('LABELS.CANCEL')
      }).then(res => {
        if (res) {
          changePayMethod();
        } else {
          this.selectedBank = this.payModel.bank;
        }
      })
    } else {
      changePayMethod();
    }
  }

  close() {
    this.modal.dismiss();
  }

}
